import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=361580d4&scoped=true&lang=html"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignIn.vue?vue&type=style&index=0&id=361580d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361580d4",
  null
  
)

export default component.exports